import HTTPClient from './http-client';

const END_POINT = '/forecastdata';

const options = {
    cache: {
        maxAge: 2 * 60 * 1000,
        exclude: { query: false }
    }
}

const loadForecasts = async ({type, source, location_id, initial_date, final_date, customer_id, runtime}) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();

  let url = `${END_POINT}?summaryType=${type}`;

  if(source){
    url += `&source_ids=${source}`;
  }

  if(location_id){
    url += `&location_ids=${location_id}`;
  }

  if(initial_date){
    url += `&date_start=${initial_date}`;
  }

  if(final_date){
    url += `&date_end=${final_date}`;
  }

  if(customer_id){
    url += `&customer_ids=${customer_id}`;
  }

  if(runtime){
    url += `&runtime=${runtime}`;
  }

  return api.get(url, options);
}

const loadFlowForecasts = async (type, source, location_id, runtime, final_runtime) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    let url = `${END_POINT}/flow?summaryType=${type}&source_id=${source}&location_id=${location_id}&runtime=${runtime}&runtime_end=${final_runtime}`;
    return api.get(url, options);
}

export {
  loadForecasts,
  loadFlowForecasts,
}
